import { h, Component } from 'preact';
import style from './style';

var classNames = require('classnames/bind');
var cx = classNames.bind(style);

import { route } from 'preact-router';

import { apiGetRequest } from '../../../components/utils/api';
import SideMenu from '../../../components/sideMenu';
import Back from '../../../components/back';
import SearchResultCard from '../../../components/search/searchResultCard';
import Input from '../../../components/search/input';
import SpecificDatePicker from '../../../components/search/datePickers/specificDatePicker';
import RangeDatePicker from '../../../components/search/datePickers/rangeDatePicker';
import Rate from '../../../components/search/rate';

import Dropdown from 'react-dropdown'

import Collapsible from 'react-collapsible';

import Select from 'react-select';
import AsyncSelect from 'react-select/lib/Async';
import 'react-day-picker/lib/style.css';

const qs = require('query-string');


export default class DemoSearch extends Component {
	constructor(props) {
        super(props);
        this.state = {
            searchValue: "",
            searchResults: [],
            searchEngine: {},
            page: 1,
            pages: 1,
            nextPageLoad: false,
            sort: { value: '', label: 'Sort by Relevance' },
            loading: true,
            emptySearch: false,
            resultCount: 0
        }
    }

    getSearchEngine() {
        apiGetRequest("search/demo/retrieve/" + this.props.id).then((data) => {
            console.log(data);
            this.setState({searchEngine: data, loading: false});
        })
    }

    componentDidMount() {
        this.getSearchEngine()
    }

    search(nextPage = false) {
        this.setState({nextPageLoad: true});
        if (nextPage) {
            var elem = document.getElementById("resultsContainer");
            setTimeout(() => {
                elem.scrollTo(0, elem.scrollHeight);
            }, 33);
        }

        apiGetRequest("search/demo/search?" + this.state.qsString).then((data) => {
            console.log("Search Results:", data);
            if (nextPage) {
                var results = this.state.searchResults;
                var newResults = data.results;

                results = results.concat(newResults);
				this.setState({searchResults: results, nextPageLoad: false});
            } else {
                var pages = Math.ceil(data.count / 10);

                let state = {searchResults: data.results, pages: pages, nextPageLoad: false, resultCount: data.count};
                
                if (data.results.length == 0) {
                    state.emptySearch = true;
                };

                this.setState(state);
            }
        }).catch((error) => {
            console.log(error);
            this.props.changeAppLoading(false);
        })
    }

	queryStringCall(nextPage = false, sortChange = false) {
        var elem = document.getElementById("resultsContainer");
		var qsObj = {
			"search_engine": this.props.id,
			"search_value": this.state.searchValue,
            "page": this.state.page,
            "sort": this.state.sort.value,
        };

        if (!nextPage) {
            qsObj["page"] = 1;
            if (!sortChange) {
                qsObj["sort"] = "";
                this.setState({page: 1, sort: { value: '', label: 'Sort by Relevance' }})
            }
        }

		var qsString = qs.stringify(qsObj);
		this.setState({qs: qsObj, qsString: qsString, emptySearch: false});
        if (this.state.searchValue.length > 0) {
            if (!nextPage) {
                this.setState({nextPageLoad: true, searchResults: []});
                elem.scrollTo(0, 0);
            }
            this.props.mixpanel.track("Demo Searched", qsObj)
            this.search(nextPage);
        };
    }
    
    nextPage() {
        this.setState({page: this.state.page += 1}, () => {
            this.queryStringCall(true);
        });
    }

    changeSort(value) {
        this.setState({sort:value}, () => {
            this.queryStringCall(false, true);
        })
    }


	render() {
        if (this.state.loading) {
            return(
                <div />
            )
        } else {
            return (
                <div class={cx("home")}>
                    <div class={cx("content")}>
                        <div class={cx("searchBarContainer")}>
                            <Back 
                                cta={"Back to Search Engine List"}
                                callback={() => {
                                    route("/demo/list/")
                                }}
                            />
                            <h1>{this.state.searchEngine.name}</h1>
                            <h1>What do you want to find today?</h1>
                            <div class={cx("searchBar")}>
                                <form onSubmit={(e) => {
                                    e.preventDefault();
                                    this.queryStringCall()
                                }}>
                                    <Input 
                                        value={this.state.searchValue}
                                        onChange={(e) => this.setState({searchValue: e.target.value})}
                                        placeholder="Enter your search" 
                                    />
                                </form>
                            </div>
                        </div>
    
                        <div id="resultsContainer" class={cx("resultsContainer")}>
                            {!this.state.emptySearch && this.state.resultCount != 0 &&
                                <div class={cx("result-count")}>
                                    <p><small>About {this.state.resultCount.toLocaleString( { minimumFractionDigits: 4 })} results</small></p>
                                </div>
                            }

                            <div class={cx("sort")}>
                                <Dropdown 
                                    options={
                                        [
                                            { value: '', label: 'Sort by Relevance' },
                                            { value: 'video_publishedAt', label: 'Sort by Date Published Ascending' },
                                            { value: '-video_publishedAt', label: 'Sort by Date Published Descending' },
                                        ]
                                    } 
                                    onChange={(val) => this.changeSort(val)} 
                                    value={this.state.sort} 
                                    placeholder="Sort"
                                />
                            </div>
                        
                            {this.state.searchResults.map((item, index) => (
                                <SearchResultCard 
                                    item={item}
                                    key={index}
                                    mixpanel={this.props.mixpanel}
                                    demo
                                />
                            ))}
                            {this.state.searchResults.length !== 0 && this.state.pages > 1 && this.state.page !== this.state.pages && !this.state.nextPageLoad &&
                                <div class={cx("button")} onClick={() => this.nextPage()}>
                                    <p>Load More</p>
                                </div>
                            }
    
                            {this.state.nextPageLoad && 
                                <div id="loadIndicator" class={cx("nextPageLoad")}>
                                    <p class={cx("emoji")}>🔍</p>
                                    <p>Loading</p>
                                </div>
                            }

                            {this.state.emptySearch &&
                                <p><span style={{fontSize: "20px"}}>🤷</span> Couldn't find anything, try simplifying your search word(s) or reducing filters</p>
                            }
    
                        </div>
    
                    </div>
                </div>
            );
        }
	}
}




// WEBPACK FOOTER //
// ./routes/demo/demoSearchEngine/index.js